import { create } from 'zustand';

type SelectedLocationState = {
    selectedLocation?: string;
    setSelectedLocation: (locationUuid?: string) => void;
};

export const useSelectedLocationStore = create<SelectedLocationState>(set => ({
    selectedLocation: null,
    setSelectedLocation: (locationUuid?: string) => set({ selectedLocation: locationUuid }),
}));
